import {bus} from './EventBus.js';
export function usesPublicRanking(){return import.meta.env.VITE_SOCIAL_ENABLED==='true' && window.parent===window && !new URLSearchParams(location.search).has('s');}
let selected='STANDARD',generation=0,active=true;
export function stopPublicRanking(){active=false;generation++;}
export async function refreshPublicRanking(track=selected){
 if(!active||!usesPublicRanking()||!['STANDARD','LIVE_INTERACTIVE'].includes(track))return;
 selected=track;const current=++generation;
 bus.emit('portal:score',{state:'loading'});
 try{
   const response=await fetch(`./api/ranking?track=${track}`,{cache:'no-store',signal:AbortSignal.timeout(18000)});
   const board=await response.json();
   if(current!==generation)return;
   if(!response.ok)throw new Error('ranking unavailable');
   bus.emit('portal:board',board);bus.emit('portal:score',{state:'idle'});
 }catch{if(current===generation){bus.emit('portal:board',{source:'TRAIDENT_PUBLIC',track,state:'unavailable'});bus.emit('portal:score',{state:'unavailable'});}}
}
export function initPublicRanking(){
 if(!usesPublicRanking())return;
 void refreshPublicRanking();
 bus.on('ui:rankingRefresh',()=>void refreshPublicRanking());
 bus.on('ui:rankingTrack',({track})=>void refreshPublicRanking(track));
}
